import React from 'react';
import { CloseIcon } from '@/design-system/components/Icons';

interface CloseButtonProps {
  onClose: () => void;
  className?: string;
}

export const CloseButton: React.FC<CloseButtonProps> = ({ onClose, className }) => (
  <button
    type="button"
    onClick={onClose}
    className={`flex items-center justify-center text-ds-text-1 hover:opacity-70 transition-opacity cursor-pointer ${className ?? ''}`}
  >
    <CloseIcon className="w-6 h-6" />
  </button>
);
